<template>
  <NoticePopup v-if="hasCampaignLayerPopup" />
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import NoticePopup from '@/components/common/NoticePopup.vue'

  // campaign types
  const CAMPAIGN_TYPE_LAYER_POPUP = 'layerpopup'

  const props = defineProps({
    campaign: {
      type: Object,
      default: null,
    },
  })

  const campaignList = computed(() => props.campaign?.campaignList ?? [])
  const hasCampaignLayerPopup = computed(() =>
    campaignList.value?.some(
      (campaign) => campaign.uid === CAMPAIGN_TYPE_LAYER_POPUP,
    ),
  )
</script>
